import { jsx } from 'react/jsx-runtime';
import { I18nProvider } from '@lingui/react';
import { useEffect } from 'react';
import { i18n } from '../../../utils/i18n.js';
import { Idioma, IdiomaInfo } from '../../../utils/idioma.js';
import { Content } from '../components/content.js';
import { useUserQuery } from '../../core/hooks/use-user-query.js';
import { useKeycloak } from '../../core/context/keycloak.js';
import { useTheme } from '../../core/hooks/useTheme.js';
import { PortalTour } from '../../core/providers/tour.js';

const Header = ({
  ...rest
}) => {
  const {
    data: user
  } = useUserQuery();
  const {
    keycloak
  } = useKeycloak();
  useTheme(keycloak.realm);
  const idiomaAtual = Idioma[user?.idioma?.id ?? "PT_BR"];
  useEffect(() => {
    i18n.activate(IdiomaInfo[idiomaAtual].language);
  }, [idiomaAtual]);
  return /* @__PURE__ */ jsx(I18nProvider, { i18n, children: /* @__PURE__ */ jsx(PortalTour, { steps: [], children: /* @__PURE__ */ jsx(Content, { ...rest }) }) });
};

export { Header };
